module.exports = __webpack_public_path__ + "img/temporary.1cfef6b7.png";